import { Check, Code2, Database, Files, Globe, HardDrive, Loader2, X } from "lucide-react";
import type { AronToolStep as Step } from "../types";

export function AronToolStep({ step }: { step: Step }) {
  const Icon =
    step.status === "running" ? Loader2 : step.status === "error" ? X : Check;
  const color =
    step.status === "error"
      ? "text-red-600"
      : step.status === "running"
        ? "text-gray-400"
        : "text-emerald-500";
  const KindIcon =
    step.kind === "code"
      ? Code2
      : step.kind === "web_search"
        ? Globe
        : step.kind === "files"
          ? Files
          : step.kind === "drive"
            ? HardDrive
            : Database;
  const req = step.kind === "api_query" ? step.request : undefined;
  const hasQuery = req?.query && Object.keys(req.query).length > 0;
  const hasBody = !!step.detail && step.detail.trim().length > 0;

  return (
    <details className="text-xs text-gray-500">
      <summary className="flex cursor-pointer list-none select-none items-center gap-1.5 py-0.5 hover:text-gray-700 dark:hover:text-gray-300">
        <KindIcon size={12} className="shrink-0 opacity-60" />
        <span className="min-w-0 flex-1 truncate">{step.label}</span>
        <Icon
          size={12}
          className={`shrink-0 ${color} ${step.status === "running" ? "animate-spin" : ""}`}
        />
      </summary>
      {req && (
        <div className="ml-5 mt-1 border border-gray-100 bg-gray-50 p-1.5 font-mono text-[10px] leading-relaxed break-all text-gray-500 dark:border-gray-700 dark:bg-gray-800">
          <div>
            <span className="text-gray-400">żądanie:</span> {req.method} {req.path}
          </div>
          {hasQuery && (
            <div>
              <span className="text-gray-400">parametry:</span> {JSON.stringify(req.query)}
            </div>
          )}
          {req.status_code != null && (
            <div>
              <span className="text-gray-400">status:</span> {req.status_code}
            </div>
          )}
        </div>
      )}
      {/* Server tools (code / web): show the actual code / search query. */}
      {!req && hasBody && (
        <pre className="ml-5 mt-1 max-h-48 overflow-auto bg-gray-900 p-1.5 text-[10px] leading-relaxed whitespace-pre-wrap text-gray-100">
          {step.detail}
        </pre>
      )}
    </details>
  );
}
